/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindAllQueryResponse,
  TelegramProductsControllerFindAllQueryParams,
  TelegramProductsControllerFindAll401,
} from '../../types/TelegramProductsControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindAll } from '../../methods/telegramProductsFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindAllQueryKey = (params?: TelegramProductsControllerFindAllQueryParams) =>
  [{ url: '/api/telegram/products' }, ...(params ? [params] : [])] as const;

export type TelegramProductsFindAllQueryKey = ReturnType<typeof telegramProductsFindAllQueryKey>;

export function telegramProductsFindAllQueryOptions(
  params?: TelegramProductsControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindAllQueryKey(params);
  return queryOptions<
    TelegramProductsControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindAll401>,
    TelegramProductsControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindAll(params, config);
    },
  });
}

/**
 * {@link /api/telegram/products}
 */
export function useTelegramProductsFindAll<
  TData = TelegramProductsControllerFindAllQueryResponse,
  TQueryData = TelegramProductsControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindAllQueryKey,
>(
  params?: TelegramProductsControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramProductsFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindAll401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
